<div class="h-full relative overflow-auto">
  @if(hasCustomTitle){
  <p class="text-xl text-[#53565B] font-semibold">
    <span [innerHTML]="title"></span>
  </p>
  }@else{
  <div>
    <p class="text-xl text-[#53565B] font-semibold">
      About
      <span class="text-k-blue font-bold"> {{ title }} </span>
    </p>
  </div>
  }
  <div class="w-full h-[365px] p-1 bg-slate-400 my-6 relative">
    <!-- <div class=""> -->
    <iframe
      [src]="iframeSrc"
      frameborder="0"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
    ></iframe>
    <!-- </div> -->
  </div>
  <div class="h-fit w-full">
    @for(details of setupInstructions; track $index){
    <div class="py-4 px-6 border mb-3 w-full h-fit border-[#DCDCDC] rounded">
      <div class="w-full flex gap-6 h-fit">
        @if(details?.image){
        <div class="w-16 h-16 p-2 bg-[#ebf0fa]">
          <img [src]="details?.image" alt="" class="w-full h-full bg-transparent" />
        </div>
        }
        <div [ngClass]="{ 'w-[88%]': !!details?.image, 'w-full': !details?.image }">
          <p class="font-bold text-lg">
            {{ details.title }}
          </p>
          <div class="text-lg font-bold text-[#18191C] mb-2 font-open-sans">
            {{ details.description }}
          </div>
          <ul class="list-disc ml-6">
            @for (item of details?.list; track $index) {
            <li class="my-1 text-[#515765] text-sm leading-6">
              <span [innerHTML]="item"></span>
            </li>
            }
          </ul>
          <div class="text-[#18191C] mt-2 font-open-sans text-sm mb-2">
            {{ details.note }}
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
